import { OVERTIME_API_KEY } from '@/config/env'
import type { SupportedNetwork } from '@/Overtime/types/network'
import { generalConfig } from '@/Overtime/config/general'

const isLocalhost =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === '::1') // IPv6 localhost

export const getProtectedApiRoute = (
  networkId: SupportedNetwork,
  route: string,
  queryString?: string
) => {
  const adminApiKey = OVERTIME_API_KEY
  return `${generalConfig.API_URL}/overtime-v2/networks/${networkId}/${route}${queryString ? `?${queryString}` : ''}${
    isLocalhost ? `${queryString ? '&' : '?'}adminApiKey=${adminApiKey}` : ''
  }`
}
